import { createBrowserHistory, createHashHistory } from 'history';

export default createHashHistory({basename: "/"});